/**
 * MemberAddressService
 * Service for MemberAddress entity operations
 * Route: api/member-addresses
 * Controller: MemberAddressesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MemberAddressService
 * Handles member address CRUD operations
 * Maps to /api/member-addresses endpoint
 */
export class MemberAddressService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MemberAddressService.DEFAULT_SERVICE_PATH,
            basePath: MemberAddressService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MemberAddressService.DEFAULT_SERVICE_PATH = 'members';
MemberAddressService.BASE_PATH = 'api/member-addresses';
//# sourceMappingURL=MemberAddressService.js.map